import { errorsManager } from "../errors/errorsManager"
import {
  getUTMParams,
  getCookieValue,
  buildEventId,
  getOfferPriceTrackingProperties,
  getOfferPriceId,
} from "./trackingUtils"
import Bugsnag from "@bugsnag/js"

export class TrackingServiceGTM {
  constructor(pipelineConfig) {
    this.defaultParameters = {
      pageCode: window.location.pathname.split(pipelineConfig.pathPrefix)[1].split("/")[0] || null,
      page: window.location.pathname.split(pipelineConfig.pathPrefix)[1].split("/")[0] || null,
      pipe: pipelineConfig.pathPrefix,
      claritySessionID: decodeURIComponent(getCookieValue("_clsk")).split("^")[0] || null,
      pipe_id: pipelineConfig.pipelineId,
      language: pipelineConfig.language,
      geography: pipelineConfig.geography,
      brand_code: pipelineConfig.brandCode,
      brand: pipelineConfig.brandCode,
      pipe_series: pipelineConfig.series,
      pipeSeries: pipelineConfig.series,
      eventSourceSystem: "cppv3",
      eventSourcePlatform: "web",
    }
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []
    }
  }

  isGtmAvailable() {
    return Array.isArray(window.dataLayer) && typeof window.dataLayer.push === "function"
  }

  _mergeData(eventData) {
    const utm = getUTMParams()
    return {
      ...this.defaultParameters,
      ...utm,
      ...eventData,
    }
  }

  _push(event, data = {}) {
    const payload = this._mergeData(data)

    if (!this.isGtmAvailable()) {
      errorsManager.reportError(
        new Error(`[TrackingManager][GTM DataLayer] Service unavailable: ${event}`),
      )
      return
    }

    if (!payload) {
      errorsManager.reportError(
        new Error(
          `[TrackingManager][GTM DataLayer] No payload for event ${event}: ${JSON.stringify(data)}`,
        ),
      )
      return
    }

    try {
      window.dataLayer.push({ event, ...payload })
    } catch (err) {
      errorsManager.reportError(
        new Error(
          `[TrackingManager][GTM DataLayer] Failed to push event ${event}: ${err.message || err}`,
        ),
      )
    }
  }

  initDefaultSelectedPlan() {
    const trackingProperties = getOfferPriceTrackingProperties()

    this._push("plan selected", trackingProperties)
  }

  trackSelectPlan() {
    const trackingProperties = getOfferPriceTrackingProperties()

    this._push("plan selected", trackingProperties)
  }

  trackGetMyPlanClicked() {
    const trackingProperties = getOfferPriceTrackingProperties()

    this._push("get plan clicked", trackingProperties)
  }

  trackOrderCompleted(currentOffer) {
    if (!currentOffer) {
      errorsManager.reportError(new Error(`[TrackingManager][GTM DataLayer] No offer found.`))
      return
    }

    const store = (window.Alpine && Alpine.store && Alpine.store("data")) || {}
    const trackingProperties = getOfferPriceTrackingProperties(currentOffer)
    const orderId = store?.values?.id?.toString?.() || null
    const offerPriceId = getOfferPriceId(currentOffer)

    const eventId = buildEventId({
      orderId,
      pipelineId: this.defaultParameters.pipe_id,
      offerPriceId,
    })

    const trackingPayload = {
      ...trackingProperties,
      eventId,
    }

    this._push("order completed", trackingPayload)
  }

  /**
   * Retrieves funnel marker tracking properties for a given template name (file name).
   *
   * @param {string} templateName - File name of the template.
   * @returns {string|Array} Funnel marker/s for the template, or an empty string if not found.
   */
  getTemplateTrackingPropertiesFunnelMarkers(templateName) {
    const sanitizedTemplateName = templateName.replace(/\//g, "") // Removes slashes from the template name. Example: "/00-landing/" -> "00-landing"
    const templateNames = pipelineConfig.templateTrackingProperties
    if (!templateNames) return ""

    const templateProperties = templateNames[sanitizedTemplateName] || {}

    return templateProperties.funnelMarker || ""
  }

  trackPageView() {
    this.pageState = window.Alpine.store("pageState")
    const templateName = this.pageState?.activeStepFileSlug || "unknown"
    const trackingFunnelMarkers = this.getTemplateTrackingPropertiesFunnelMarkers(templateName)

    this._push("page viewed", {
      funnelMarker: trackingFunnelMarkers,
    })
  }

  async isUserIdentified() {
    return true
  }

  trackSystemEvent() {}
  setEventToSessionStorage() {}
  trackSessionStorageClickEvent() {}
  trackClick() {}
  trackIdentify() {}
  resetUserData() {}
}
